import { UserClassModel } from '@/models/class/class';
import { MilestoneModel } from '@/models/journey/journey';
import { journeyAPI } from '@/providers/apis/journey/journey';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'domain-journey-panel',
})

export default class DomainJourneyPanelComponent extends Vue {

    // -----------------------------------------------------
    // Properties

    @Prop({default: []})
    private activeClasses: any;

    @Prop()
    private userId!: string;

    @Prop()
    private domain: any;

    private activeJourney: any = null;

    private domainJourney: any = [];


    // -----------------------------------------------------
    // Hooks

    private created() {
        this.loadData();
    }


    // -----------------------------------------------------
    // Actions

    private onSelectJourney(journey: any) {
        this.activeJourney = journey;
        this.fetchMilestones(journey);
    }

    private onSelectMilestone(milestone: any) {
        this.fetchMilestoneLessons(milestone);
    }

    // -----------------------------------------------------
    // Methods

    private loadData() {
        const activeClasses = JSON.parse(JSON.stringify(this.activeClasses));
        const domainJourney: any = [];
        activeClasses.forEach((item: any) => {
            const cloneObj = Object.assign({}, item);
            if (cloneObj.milestones) {
                cloneObj.milestones.map((milestone: MilestoneModel) => {
                    let lessons = milestone.lessons;
                    if (lessons) {
                        lessons = lessons.filter((lesson) => lesson.domainCode === this.domain.domainCode);
                        milestone.lessons = lessons;
                    }
                    return milestone;
                });
            }
            domainJourney.push(cloneObj);
        });
        this.domainJourney = domainJourney;
    }

    private fetchMilestones(classDetail: UserClassModel) {
        const params = {
            courseId: classDetail.courseId,
            fwCode: classDetail.framework || 'CCSS',
            queryParams: {
                class_id: classDetail.id,
                user_id: this.userId,
            },
        };
        if (!classDetail.milestones) {
            journeyAPI.fetchClassMilestones(params).then((milestones) => {
                this.$set(classDetail, 'milestones', milestones);
             });
        }
    }

    private fetchMilestoneLessons(milestone: MilestoneModel ) {
        const activeJourney = this.activeJourney;
        const params = {
            courseId: activeJourney.courseId,
            milestoneId: milestone.milestoneId,
        };
        if (!milestone.lessons) {
            journeyAPI.fetchMilestoneDetails(params).then((lessons) => {
                // lessons = lessons.filter(lesson => lesson.domainCode === this.domain.domainCode);
                this.$set(milestone, 'lessons', lessons);
             });
        }
    }





}
